import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX} from "../constants";

const metricProcessName = "SCC_STOW";

export async function getInductPackageMetrics(request) {
    const metricName = "getInductPackageMetrics";
    const args = getAPIGatewayRequest(request);
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformInductPackageMetrics(response.data.groupedPackageMetrics);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

function getAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getPackageMetric",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

function transformInductPackageMetrics(metricsMapInput) {
    const metricsMapOutput = {};
    for (const key in metricsMapInput["INDUCTED"]) {
        if (key) {
            metricsMapOutput[key] = {
                ...metricsMapOutput[key],
                "inductedPackages": metricsMapInput["INDUCTED"][key],
            }
        }
    }
    for (const key in metricsMapInput["INDUCTED_AT_STATION"]) {
        if (key) {
            metricsMapOutput[key] = {
                ...metricsMapOutput[key],
                "inductedPackages": metricsMapInput["INDUCTED_AT_STATION"][key],
            }
        }
    }
    for (const key in metricsMapInput["CUMULATIVE_INDUCTED"]) {
        if (key) {
            metricsMapOutput[key] = {
                ...metricsMapOutput[key],
                "cumulativeInducted": metricsMapInput["CUMULATIVE_INDUCTED"][key],
            }
        }
    }

    for (const key in metricsMapInput["RECEIVED"]) {
        if (key) {
            metricsMapOutput[key] = {
                ...metricsMapOutput[key],
                "receivedPackages": metricsMapInput["RECEIVED"][key],
            }
        }
    }
    for (const key in metricsMapInput["PENDING_INDUCT"]) {
        if (key) {
            metricsMapOutput[key] = {
                ...metricsMapOutput[key],
                "receivedPackages": metricsMapInput["PENDING_INDUCT"][key],
            }
        }
    }
    for (const key in metricsMapInput["PLANNED_CURRENT_CYCLE_INDUCTED"]) {
        if (key) {
            metricsMapOutput[key] = {
                ...metricsMapOutput[key],
                "plannedInducted": metricsMapInput["PLANNED_CURRENT_CYCLE_INDUCTED"][key],
            }
        }
    }
    for (const key in metricsMapInput["UNPLANNED_CURRENT_CYCLE_INDUCTED"]) {
        if (key) {
            metricsMapOutput[key] = {
                ...metricsMapOutput[key],
                "unplannedInducted": metricsMapInput["UNPLANNED_CURRENT_CYCLE_INDUCTED"][key],
            }
        }
    }
    return metricsMapOutput;
}



// WEBPACK FOOTER //
// ./src/resources/InductResource.js